<template>
    <div>
        <el-table :data="tabledata" :span-method='mergeCols' :border='true'>
            <el-table-column label="电费站点" prop="stationName">
                <template slot-scope="{ row }">
                    <el-tag type="primary" size='mini' v-if="row.status==1">已转移</el-tag>
                    <span>{{ row.stationName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="电表号" prop="ammeterNo">
                <template slot-scope="{ row }">
                    <span>{{ row.ammeterNo || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="设备总数/插槽总数" prop="stationId" min-width='140'>
                <template slot-scope="{ row }">
                    <span>{{ row.deviceNum || 0 }}/{{ row.slotNum || 0 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="上次度数" prop="lastRecordPower">
                <template slot-scope="{ row }">
                    <span>{{ row.lastRecordPower + 'kwh' || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="本次度数" prop="recordPower">
                <template slot-scope="{ row }">
                    <span>{{ row.recordPower + 'kwh' || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="应结算度数" prop="intervalPower" min-width='100'>
                <template slot-scope="{ row }">
                    <span>{{ row.intervalPower + 'kwh' || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="lastRemainMoney" label="剩余金额" min-width='100'>
                <template slot="header" slot-scope="scope">
                    <div class="a-flex-rfsc">
                        <span>剩余金额</span>
                        <el-tooltip class="item" effect="dark" content="预充值账单的上期剩余费用" placement="top">
                            <span class="el-icon-question"></span>
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.lastRemainMoney) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="needPayAmount" label="本期应付" min-width='100'>
                <template slot="header" slot-scope="scope">
                    <div class="a-flex-rfsc">
                        <span>本期应付</span>
                        <el-tooltip class="item" effect="dark" content="账单的合计应付电费。后付费：即本期电费；预付费：即本次预交的费用" placement="top">
                            <span class="el-icon-question"></span>
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.needPayAmount) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="区间电费" prop="intervalFee">
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.intervalFee) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="区间收益" prop="intervalIncome">
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.intervalIncome) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="区间电费占比" prop="intervalRatio" min-width='100'>
                <template slot-scope="{ row }">
                    <span>{{ util.numFormat(row.intervalRatio) }}%</span>
                </template>
            </el-table-column>
            <el-table-column label="我方电费估算" prop="innerPriceId" min-width='100'>
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.innerPrice) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="他方电费估算" prop="outsidePriceId" min-width='100'>
                <template slot-scope="{ row }">
                    <span>￥{{ util.numFormat(row.outsidePrice) }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import util from '../../../../src/utils/util'
    export default {
        data() {
            return {
                util: util,
            }
        },
        props:{
            tabledata: {
                default: ()=>{
                    return []
                }
            }
        },
        computed: {
            // 获取所有单元格合并数据
            spanArr() {
                if(!this.tabledata.length) return []
                const mergeCols = ['stationName','ammeterNo','stationId','ammeterNo','ammeterNo','ammeterNo','ammeterNo','ammeterNo','ammeterNo','stationName','ammeterNo','ammeterNo','ammeterNo'] // 需要合并的列（字段）
                return util.getMergeCells(this.tabledata, mergeCols, mergeCols)
            }
        },
        methods:{
            // 合并行
            mergeCols ({ row, column, rowIndex, columnIndex }) {
                return this.spanArr[rowIndex][columnIndex]
            },
        }
    }
</script>